import { ShieldCheck, Banknote, Paintbrush, MessageSquare, CheckCircle2 } from "lucide-react";

const features = [
  {
    icon: ShieldCheck,
    title: "Erfaren & seriös målerifirma",
    description: "Med över 15 års erfarenhet av fasadmålning vet vi vad som krävs för ett hållbart resultat.",
  },
  {
    icon: Banknote,
    title: "Fast pris – inga överraskningar",
    description: "Du får alltid ett tydligt fastpris innan vi börjar. Inga dolda kostnader eller tilläggsarbeten.",
  },
  {
    icon: Paintbrush,
    title: "Rätt förarbete",
    description: "Vi lägger stor vikt vid tvättning, skrapning och grundning – grunden för ett hållbart resultat.",
  },
  {
    icon: MessageSquare,
    title: "Kommunikation genom hela projektet",
    description: "Du får löpande uppdateringar och vi finns alltid tillgängliga för frågor under arbetets gång.",
  },
  {
    icon: CheckCircle2,
    title: "Slutbesiktning innan avslut",
    description: "Vi går igenom allt tillsammans och säkerställer att du är 100% nöjd innan projektet avslutas.",
  },
];

export default function WhyChooseUs() {
  return (
    <section className="section-padding bg-slate-50" data-testid="why-choose-us-section">
      <div className="container mx-auto max-w-6xl">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <span className="text-sm font-semibold tracking-wider uppercase text-[#b91c1c]">
            Varför välja oss
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-slate-900 tracking-tight">
            En målerifirma du kan lita på
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Vi sätter kvalitet och trygghet i första rummet. Här är varför hundratals kunder valt oss.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="feature-card bg-white p-8 rounded-2xl border border-slate-200/60 hover:border-[#b91c1c]/20"
              data-testid={`feature-card-${index}`}
            >
              <div className="w-14 h-14 bg-[#b91c1c]/10 rounded-xl flex items-center justify-center mb-6">
                <feature.icon className="w-7 h-7 text-[#b91c1c]" />
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
